module.exports = __webpack_public_path__ + "static/media/background_sciencedysten.3bf835f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/background_sciencedysten.png
// module id = 1466
// module chunks = 0